export const applyPinSignal = (
	current: string[],
	fromInstructorId: string,
	isPinned: boolean
): string[] => {
	if (isPinned) {
		return current.includes(fromInstructorId) ? current : [...current, fromInstructorId];
	}
	return current.filter((id) => id !== fromInstructorId);
};
